module.exports = {
	model: {
		media: {},
	},

	hooks: {
		showMediaDetails: function($element, options){
			this.model.media = options.media
			this.refresh()
		}
	}
}